import axios from 'axios'
import { processRound } from '@/store/modules/rounds'
import { processAthlete } from '@/store/modules/athletes/detail'

// state
export const state = {
  isRoundLoading: false,
  isAthletesLoading: false,
  round: false,
  athletes: false,
}

// getters
export const getters = {
}

// mutations
export const mutations = {
  fetchRoundStarted(state) {
    state.isRoundLoading = true
  },
  fetchRoundSuccess(state, { round }) {
    state.round = processRound(round, new Date())
    state.isRoundLoading = false
  },
  fetchRoundFailed(state) {
    state.isRoundLoading = false
  },
  fetchRoundAthletesStarted(state) {
    state.isAthletesLoading = true
  },
  fetchRoundAthletesSuccess(state, { athletes }) {
    state.athletes = athletes.map((athlete) => processAthlete(athlete))
    state.isAthletesLoading = false
  },
  fetchRoundAthletesFailed(state) {
    state.isAthletesLoading = false
  },

}
// actions
export const actions = {
  async fetchRound({ commit }) {
    let round = null
    try {
      commit('fetchRoundStarted')
      round = await axios.get(`epl-signup/round`)
      commit('fetchRoundSuccess', { round })
    } catch (e) {
      commit('fetchRoundFailed')
    }
    return round
  },
  async fetchAthletes({ commit }, { roundId }) {
    let athletes = null
    try {
      commit('rounds/assignAthleteIntoRound/fetchAthletesStart', null, { root: true })
      athletes = await axios.get(`epl-signup/athletes`)
      commit('rounds/assignAthleteIntoRound/fetchAthletesSuccess', { athletes, roundId }, { root: true })
    } catch (e) {
      commit('rounds/assignAthleteIntoRound/fetchAthletesFailed', null, { root: true })
    }
    return athletes
  },
}
